<template>
  <div class="progress-container">
    <div class="progress-bar" :style="{ width: progress + '%' }"></div>
  </div>
</template>
<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
      default: 0,
    },
  },
}
</script>

<style scoped>
.progress-container {
  width: 100%;
  height: 16px;
  background-color: #fdfdfb;
  border-radius: 6px;
  overflow: hidden;
  border: solid 1px #ddd;
  margin-top: 10px;
  margin-bottom: 10px;
}

.progress-bar {
  height: 100%;
  background-color: #18693c;
  border-radius: 6px;
  transition: width 0.3s ease-in-out;
}
</style>
